<app-layout>
  <div class="row">
    <div class="col-lg-6 col-md-12 offset-lg-3 mt-3 mr-3">
      <div class="card">
        <div class="card-status-top bg-success"></div>
        <div class="card-body">
          <h3 class="card-title">Teklifiniz başarıyla kaydedildi.</h3>
          <div class="text-blue clickable" (click)="showDetails()">Teklifi Görüntüle</div>
          <div class="text-blue clickable" (click)="showTeklifler()" *ngIf="isAuthenticated">Teklifler Sayfasına Git</div>

        </div>
      </div>
    </div>
  </div>
</app-layout>
